<app-megamenu></app-megamenu>

<div class="service-page">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="hero-background"></div>
    <div class="container">
      <div class="hero-content">
        <h1>General Pest Control</h1>
        <p class="hero-subtitle">Comprehensive protection against common household pests with safe, effective treatments that keep your home pest-free year-round.</p>
        <div class="hero-actions">
          <button mat-raised-button class="cta-button" (click)="navigateToContact()">
            <mat-icon>request_quote</mat-icon>
            Get Your Free Quote
          </button>
          <button mat-button class="phone-button" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            Call {{ config.phone.display }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Pests We Control Section -->
  <div class="pests-section">
    <div class="container">
      <h2>Pests We Control</h2>
      <p class="section-subtitle">Our general pest control service targets the most common household invaders.</p>
      
      <div class="pests-grid">
        <div *ngFor="let pest of pests" class="pest-card">
          <mat-icon>{{ pest.icon }}</mat-icon>
          <h3>{{ pest.name }}</h3>
          <p>{{ pest.description }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Features Section -->
  <div class="features-section">
    <div class="container">
      <h2>Why Choose Our General Pest Control?</h2>
      
      <div class="features-grid">
        <div *ngFor="let feature of features" class="feature-card">
          <div class="feature-icon">
            <mat-icon>{{ feature.icon }}</mat-icon>
          </div>
          <div class="feature-content">
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Process Section -->
  <div class="process-section">
    <div class="container">
      <h2>Our Treatment Process</h2>
      
      <div class="process-steps">
        <div class="step">
          <div class="step-number">1</div>
          <div class="step-content">
            <h3>Inspection</h3>
            <p>A thorough property inspection to identify pest issues and entry points</p>
          </div>
        </div>
        
        <div class="step">
          <div class="step-number">2</div>
          <div class="step-content">
            <h3>Treatment Plan</h3>
            <p>Customized treatment strategy based on your specific pest problems</p>
          </div>
        </div>
        
        <div class="step">
          <div class="step-number">3</div>
          <div class="step-content">
            <h3>Application</h3>
            <p>A professional exterminator will apply EPA-approved treatments inside and outside your property</p>
          </div>
        </div>
        
        <div class="step">
          <div class="step-number">4</div>
          <div class="step-content">
            <h3>Follow-up</h3>
            <p>Regular monitoring and maintenance to ensure long-term protection</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- CTA Section -->
  <div class="cta-section">
    <div class="container">
      <h2>Ready to Protect Your Home?</h2>
      <p>Get started with a free inspection and customized treatment plan today.</p>
      <div class="cta-buttons">
        <button mat-raised-button class="primary-cta" (click)="navigateToContact()">
          <mat-icon>request_quote</mat-icon>
          Schedule Free Inspection
        </button>
        <button mat-button class="secondary-cta" (click)="callPhone()">
          <mat-icon>phone</mat-icon>
          Call Now
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>